<template>
  <div
    class="modal fade"
    id="confirm-search-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="confirm-search-modal-label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header no-border">
          <h2 class="h4 m-0" id="confirm-search-modal-label">
            Confirm your search
          </h2>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pt-0">
          <div class="container px-0 px-md-3 pb-4">
            <dl class="row bg-light py-3 mb-4">
              <dt class="col-5">Location</dt>
              <dd class="col-7 mb-2">{{ location }}</dd>
              <dt class="col-5">Search type</dt>
              <dd class="col-7 mb-2">{{ reportType.Name }}</dd>
              <dt class="col-5">Radius</dt>
              <dd class="col-7 mb-2">{{ reportType.SearchRadius }} km</dd>
              <template v-if="showPrice">
                <dt class="col-5">Price</dt>
                <dd class="col-7 mb-0 text-primary">£{{ price }}</dd>
              </template>
            </dl>

            <p>
              By clicking below you agree to the parameters of the search
              (location, radius and search type) and you agree to pay the price
              indicated. We cannot accept refund requests for searches made in
              error.
            </p>

            <div class="d-flex justify-content-between pt-3">
              <button
                type="button"
                class="btn btn-outline-primary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                @click="$emit('agree')"
              >
                I agree
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmSearchModal",

  props: {
    reportType: {
      type: Object,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    showPrice: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    location() {
      if (
        typeof this.position.lat !== "number" ||
        typeof this.position.lng !== "number"
      ) {
        return "";
      }
      return `${this.position.lat.toFixed(5)}, ${this.position.lng.toFixed(5)}`;
    },
    price() {
      return typeof this.reportType.ListPrice === "number"
        ? this.reportType.ListPrice.toFixed(2)
        : "";
    }
  }
};
</script>
